import { useCallback } from 'react';
import {
	authMeQuery,
	useUnauthorizedResponse,
	useAxiosInstance,
	usePoQuery,
} from '@gov-nx/api';
import { useExtraConfigContext } from '@gov-nx/core/app';
import type { ApiCallback } from '@gov-nx/core/hooks';
import { useApiCallback, useStorageListener } from '@gov-nx/core/hooks';
import { useAuthStore } from '@gov-nx/store';

export const useAuthMeQuery = () => {
	const { setCallback, onError, onSuccess } = useApiCallback();
	const { extraConfig } = useExtraConfigContext();
	const { axiosInstance } = useAxiosInstance();
	const logout = useAuthStore('logout');
	const setUser = useAuthStore('setUser');
	const { persisKey } = extraConfig.store;
	const authKey = `${persisKey}:auth`; //TODO: move useStorageListener somewhere closer to store definition
	const { isUnauthorizedResponse } = useUnauthorizedResponse();

	useStorageListener(authKey, logout, window);

	const meQuery = usePoQuery({
		queryKey: ['po-auth-me'],
		queryFn: () => authMeQuery(axiosInstance),
		onSuccess: (data) => {
			setUser({ loa: data.loa, typ_prihlaseni: data.typ_prihlaseni });
			onSuccess();
		},
		onError: (e) => {
			if (isUnauthorizedResponse(e) === false) {
				onError(e as Error);
			}
		},
		enabled: false,
		retry: 1,
	});

	const fetch = useCallback(
		async ({ ...args }: ApiCallback<undefined, Error>): Promise<void> => {
			setCallback({ ...args });
			await meQuery.refetch();
		},
		[meQuery, setCallback]
	);

	return { fetch };
};
